import styled from "styled-components"
import {Row} from "@irati/ui/src/Layout"

export const StyledRow = styled(Row)`
  margin-bottom: 10px;
  ${({theme}) => theme.mediaQueries.maxWidthMedia.desktop`
    display: none;
  `}
`
